export default __webpack_public_path__ + "static/media/contact.07ef5bfb.png";